@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.closeButton {
  max-height: 32px;
}

.notification {
  :global {
    --toastify-font-family: 'Lato', sans-serif;

    .Toastify {
      &__close-button {
        color: map.get(core.$fonts, fontPrimaryDisabled);

        &--icon {
          width: 12px;
          height: 12px;
        }

        &:hover {
          color: map.get(core.$fonts, fontSecondary);
        }
      }

      &__toast {
        &-body {
          cursor: pointer;
          color: map.get(core.$fonts, fontPrimary);
          font-size: 16px;
          line-height: 22px;
          max-width: 285px;

          & svg {
            margin-top: 4px;
          }

          &--content {
            @include core.font(core.$m, core.$regular, map.get(core.$fonts, fontPrimary));
          }
        }

        &--success {
          border-color: map.get(core.$colors, success);
        }

        &--warning {
          border-color: map.get(core.$fonts, warning);
        }

        &--info {
          border-color: map.get(core.$fonts, info);
        }

        &--error {
          border-color: map.get(core.$fonts, error);
        }
      }

      &__progress_bar {
        background: linear-gradient(
          90deg,
          map.get(core.$fonts, fontSecondaryDisabled),
          map.get(core.$fonts, fontSecondary),
          map.get(core.$colors, accent)
        );

        &--success {
          border-color: map.get(core.$colors, success);
        }

        &--warning {
          border-color: map.get(core.$fonts, warning);
        }

        &--info {
          border-color: map.get(core.$fonts, info);
        }

        &--error {
          border-color: map.get(core.$fonts, error);
        }
      }
    }
  }
}
